import React from 'react'; 
import { Link } from 'react-router-dom';
import axios from 'axios'; 
import '../styles/frontpage.css';
import logo from '../images/logow.png';

class FrontPage extends React.Component {
    constructor(props){
        super(props); 

        this.state = {}
        
    }

    render(){
       

        return(
            <div className="bg py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-7">
                            <img src={logo} className="img-fluid" alt="Adapticts.com" />
                            <h4 className="display-4 text-light py-5">QRCode Campaign Support System</h4>
                            <p className="text-light">QR Codes make it easy for customers to interact with your brand and op-in to active campaigns. 
                            Attract new customers, increase list signup, gain valuable customer insight, increase customer retention and conversion, 
                            boost sales, improve customer service, and generate repeat business with the Adapticts QR Code Campaign Support System.</p>
                            
                            <p className="text-light">Contact Adapticts to start using QRCodes on your campaigns today.</p>
                            
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm">
                                    <hr className="my-4 white" />
                                    <p className="text-light">Already A Member?</p>
                                    <Link className="btn btn-lg btn-outline-light mr-2" to="/login">Login</Link>
                                    <button className="btn btn-lg btn-outline-light mr-2" onClick={ () => window.location.href = 'http://adapticts.com'}>Adapticts.com</button>
                            </div>
                        </div> 
                    </div>
                </div>
        
        )
    }

}





export default FrontPage;
